import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative w-full group" }
const _hoisted_2 = {
  key: 0,
  class: "absolute left-0 right-0 bg-white border rounded mt-1 max-h-60 overflow-y-auto z-10 hidden group-focus-within:block"
}
const _hoisted_3 = ["onMousedown"]

import { useGoogleAutocomplete } from "@/utils/useGoogleAutocomplete";
import { ref, watch } from "vue";
import { PlacePrediction } from "@/types/calculators";
import { PlaceSelectedPayload } from "@/types/google-places";


export default /*@__PURE__*/_defineComponent({
  __name: 'GooglePlaceAutocompleteInput',
  props: {
    searchType: { default: "city" },
    styleType: { default: "filled" },
    initialQuery: {}
  },
  emits: ["placeSelected"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

watch(
  () => props.initialQuery,
  (newQuery: string | undefined) => {
    placeQuery.value = newQuery ?? "";
  }
);

let timeout: number | null = null;
const googleMapKey = process.env.VUE_APP_GOOGLE_MAP_KEY;
const placeQuery = ref("");

const { options, fetchSuggestions, getGeocoder } = useGoogleAutocomplete(
  "ru",
  props.searchType
);

function onInput() {
  if (timeout) clearTimeout(timeout);
  timeout = window.setTimeout(() => fetchSuggestions(placeQuery.value), 700);
}

async function selectPlace(city: PlacePrediction) {
  placeQuery.value = city.label;
  try {
    const geocoder = await getGeocoder();
    if (geocoder) {
      await getGeocoderLocation(geocoder, city);
    } else {
      await getApproximatelyLocation(city);
    }
  } catch (e) {
    console.error("Error getting prediction place: ", e);
  }
}

async function getGeocoderLocation(
  geocoder: google.maps.Geocoder,
  city: PlacePrediction
) {
  const result = await geocoder.geocode({ address: city.label });
  if (!result || result.results.length < 0) {
    throw new Error("Geocode api didn't send a response");
  }

  const location = result.results[0].geometry.location;
  const timeZone = await fetchTimeZome(location);
  emits("placeSelected", {
    location: location,
    timeZone: timeZone,
    locationName: city.city ?? city.label,
  });
}

async function getApproximatelyLocation(city: PlacePrediction) {
  const place = city.place;
  await place.fetchFields({ fields: ["location"] });

  const location = city.place.location;
  if (location) {
    const timeZone = await fetchTimeZome(location);
    emits("placeSelected", {
      location: location,
      timeZone: timeZone,
      locationName: city.label,
    });
  }
}

async function fetchTimeZome(location: google.maps.LatLng) {
  const lat = location.lat();
  const lng = location.lng();
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${Math.floor(
      Date.now() / 1000
    )}&key=${googleMapKey}`
  );
  const data = await response.json();
  return data.timeZoneId;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      id: "place",
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((placeQuery).value = $event)),
      onInput: onInput,
      autocomplete: "off",
      class: _normalizeClass(["border pl-4 pr-[6px] w-full h-[52px] rounded-[14px] sf-pro font-normal text-base focus:outline-none", {
        'border-divider bg-secondary text-muted': __props.styleType === 'filled',
        'border-muted text-black': __props.styleType === 'outline',
      }])
    }, null, 34), [
      [_vModelText, placeQuery.value]
    ]),
    (_unref(options).length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (option) => {
            return (_openBlock(), _createElementBlock("li", {
              key: option.label,
              onMousedown: ($event: any) => (selectPlace(option)),
              class: "px-3 py-2 hover:bg-gray-100 cursor-pointer text-left"
            }, _toDisplayString(option.label), 41, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})